// noinspection JSUnusedGlobalSymbols
/**
 * @author tht7 ( tht7 )
 * @date 10/07/12022 6:48 pm
 */

declare global {
  interface Window {
    candidateSession?: ICandidateSession;
  }
}

export enum CandidateSessionError {
  NO_CANDIDATE_FOUND = 'NO_CANDIDATE_FOUND',
  NO_JOB_FOUND = 'NO_JOB_FOUND',
  DEADLINE_EXPIRED = 'DEADLINE_EXPIRED',
  NO_AUDIO = 'NO_AUDIO',
  NO_VIDEO = 'NO_VIDEO',
  PERMISSIONS_BLOCKED = 'PERMISSIONS_BLOCKED',
  JOB_INACTIVE = 'JOB_INACTIVE',
  SUBSCRIPTION_PAUSED = 'SUBSCRIPTION_PAUSED',
  SUBSCRIPTION_CANCELLED = 'SUBSCRIPTION_CANCELLED',
  INTERVIEW_ALREADY_COMPLETED = 'INTERVIEW_ALREADY_COMPLETED',
}

export enum CandidateSessionWarnings {
  LOW_LIGHT = 'LOW_LIGHT',
  LOW_VOLUME = 'LOW_VOLUME',
  SLOW_CONNECTION = 'SLOW_CONNECTION',
}

export type CandidateSessionSourceType =
    | 'direct'
    | 'email'
    | 'sms'
    | 'email_reminder'
    | 'sms_reminder';

export enum CandidateSessionSourceMap {
  direct_start_inter = 'direct',
  reminder_start_inter = 'email_reminder',
  reminder_sms_start_inter = 'sms_reminder',
  email_start_inter = 'email',
  sms_start_inter = 'sms',
}

export interface ICandidateSession {
  session_id: string;
  duration: number;
  error?: keyof typeof CandidateSessionError;
  warnings?: (keyof typeof CandidateSessionWarnings)[];
  reload_count: number;
  files_uploaded_count: number;

  company_id: string;
  apiKey: string;
  job_id?: string;
  candidate_id?: string;
  video_id?: string;
  email?: string;

  source?: CandidateSessionSourceType;
  userAgent?: string;
  ip?: string;
  // `location` is a reserved property in Atlas,
  // it tells the cluster where this document should be stored.
  candidate_location?: string;

  // region EVENTS
  // general
  first_interaction?: Date;

  // form
  form_filled?: Date;
  document_uploaded?: Date;

  // top tips
  top_tips_shown?: Date;
  top_tips_clicked?: Date;
  top_tips_positive_rating?: boolean;

  // widget
  widget_shown?: Date; // when a user press the "START" button and the widget shows up

  widget_practiced?: Date; // when a user presses the "PRACTICE" button
  widget_exit?: Date; // when a user closes the widget before he submits the interview
  widget_retake_count: number; // how many times the user has pressed the "RETAKE" button

  widget_submitted?: Date; // when a user submits the interview
  widget_completed?: Date; // when a user finished the interview and the widget closes

  // endregion EVENTS

  page_closed: Date;

  createdAt: Date;
  updatedAt: Date;
}
